import * as THREE from 'three'
import GUI from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import gsap from 'gsap'


/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()



/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 2.4)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 1)
directionalLight.position.set(5, 5, 5)
scene.add(directionalLight)



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
window.addEventListener('resize', () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})



/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 5
camera.position.y = 1
scene.add(camera)



/**
 * Orbit Controls
 */
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true 



/**
 * Models
 */
const gltfLoader = new GLTFLoader()
let hamburgerModel = null

gltfLoader.load(
  '/hamburger/hamburger.glb',
  (gltf) => {
    console.log(gltf);
    gltf.scene.scale.set(0.1, 0.1, 0.1)
    gltf.scene.position.set(0, 0, 0)
    scene.add(gltf.scene)
    hamburgerModel = gltf.scene

    controls.target.copy(gltf.scene.position)
    controls.update()
  },
  undefined,
  (error) => {
    console.error('Error loading model:', error)
  }
)



/**
 * Raycaster
 */
const raycaster = new THREE.Raycaster()
const mouse = new THREE.Vector2()


let isDragging = false
let previousMousePosition = { x: 0, y: 0 }
let ingredientsVisible = false


/**
 * Event listeners to handle dragging 
 */ 
window.addEventListener('mousedown', (event) => {
    raycaster.setFromCamera(mouse, camera);

    let intersects
    if (isHamburgerSeparated) {
        intersects = raycaster.intersectObjects(hamburgerModel.children, true)
    } else {
        intersects = raycaster.intersectObject(hamburgerModel, true)
    }
    //check if the mouse is over the model
    if (intersects.length > 0) {
        isDragging = true

        event.preventDefault()

        document.body.style.cursor = 'grabbing'

        document.body.style.userSelect = 'none'

        previousMousePosition = { x: event.clientX, y: event.clientY }
    }
});


window.addEventListener('mousemove', (event) => {
    mouse.x = (event.clientX / sizes.width) * 2 - 1
    mouse.y = -(event.clientY / sizes.height) * 2 + 1

    if (isDragging) {
        const deltaX = event.clientX - previousMousePosition.x
        const deltaY = event.clientY - previousMousePosition.y

        //Update the rotation of the model
        if (isHamburgerSeparated) {
            const intersects = raycaster.intersectObjects(hamburgerModel.children, true);
            if (intersects.length > 0) {
                const selectedIngredient = intersects[0].object
                selectedIngredient.rotation.y += deltaX * 0.01
                selectedIngredient.rotation.x += deltaY * 0.01
            }
        } else {
            // Update the rotation of the original model    
            hamburgerModel.rotation.y += deltaX * 0.01
            hamburgerModel.rotation.x += deltaY * 0.01
        }

        previousMousePosition = { x: event.clientX, y: event.clientY };
    }
})


window.addEventListener('mouseup', () => {
    isDragging = false; 

    document.body.style.cursor = 'default'

    document.body.style.userSelect = ''   
})



/**
 * Event listener for double click
 */
window.addEventListener('dblclick', (event) => {
    if (hamburgerModel) {
        // update raycaster
        raycaster.setFromCamera(mouse, camera)

        const intersects = raycaster.intersectObject(hamburgerModel, true)

        if (intersects.length > 0) {
           
            if (!ingredientsVisible) {
                moveIngredientsButton.style.display = 'none'

                //Show ingredients
                hamburgerModel.children.forEach((child, index) => {
                    
                    const clonedChild = child.clone()

                    scene.add(clonedChild)

                    child.clonedChild = clonedChild

                    clonedChild.position.set(
                        hamburgerModel.position.x,
                        hamburgerModel.position.y,
                        hamburgerModel.position.z - 1 // Start position behind the hamburger
                    );

                    clonedChild.scale.copy(hamburgerModel.scale)
                    
                    let targetPosition = { x: 0, y: 0, z: 0 }
                    switch (index) {
                        case 1: //left top corner
                            targetPosition = { x: -1.7, y: 0.9, z: 0 }
                            break;
                        case 2: // right top corner
                            targetPosition = { x: 1.7, y: 1, z: 0 }
                            break;
                        case 3: // bottom left corner
                            targetPosition = { x: -1.7, y: -0.7, z: 0 }
                            break;
                        case 4: // bottom right corner
                            targetPosition = { x: 1.7, y: -1, z: 0 }
                            break;
                        default:
                            break;
                    }

                    // Animate the cloned child to the target position
                    gsap.to(clonedChild.position, {
                        x: targetPosition.x,
                        y: targetPosition.y,
                        z: targetPosition.z,
                        duration: 1.5, 
                        ease: "power2.out" 
                    })

               
                })

                ingredientsVisible = true
            } else {
                // Hide ingredients
                hamburgerModel.children.forEach((child) => {
                    if (child.clonedChild) {                        
                        gsap.to(child.clonedChild.position, {
                            x: hamburgerModel.position.x,
                            y: hamburgerModel.position.y,
                            z: hamburgerModel.position.z - 1,
                            duration: 1.5, 
                            ease: "power2.in", 
                            onComplete: () => {
                                // Remove clone from the scene
                                scene.remove(child.clonedChild)

                                // Reset the cloned child
                                child.clonedChild = null
                            }
                        })
                    }
                })

                moveIngredientsButton.style.display = 'block'
                ingredientsVisible = false; // Atualizar o estado
            }
        } 
        }
    }
);




/**
 * Event listeners for the buttons
 */
let isHamburgerSeparated = false
let isAnimating = false
const moveIngredients = () => {
    if (hamburgerModel && !isAnimating) {
        isAnimating = true // Block new clicks during the animation
        isHamburgerSeparated = true
        allowHamburgerRotation = false // Stop rotation while separating

        // Reset the rotation of the hamburger
        gsap.to(hamburgerModel.rotation, {
            x: 0,
            y: 0,
            z: 0,
            duration: 1.5,
            ease: "power2.inOut",
        });

        gsap.to(hamburgerModel.position, {
            x: hamburgerModel.initialPosition?.x || 0,
            y: hamburgerModel.initialPosition?.y || 0,
            z: hamburgerModel.initialPosition?.z || 0,
            duration: 1.5,
            ease: "power2.inOut",
            onComplete: () => {
                // Separate the ingredients
                hamburgerModel.children.forEach((child, index) => {
                    if (!child.initialPosition) {
                        // Save the initial position
                        child.initialPosition = {
                            x: child.position.x,
                            y: child.position.y,
                            z: child.position.z,
                        };
                    }

                    const targetPositions = [
                        { x: 0, y: 0, z: 0 },
                        { x: 10.5, y: -7.5, z: 0 },
                        { x: -10.5, y: -7.5, z: 0 },
                        { x: 10.5, y: 7.5, z: 0 },
                        { x: -10.5, y: 7.5, z: 0 },
                    ];

                    const targetPosition = targetPositions[index] || { x: 0, y: 0, z: 0 }

                    gsap.to(child.position, {
                        x: targetPosition.x,
                        y: targetPosition.y,
                        z: targetPosition.z,
                        duration: 1.5,
                        ease: "power2.out",
                        onComplete: () => {
                            // Change the buttons after the animation ends
                            moveIngredientsButton.style.display = 'none'
                            returnHamburgerButton.style.display = 'block'
                            isAnimating = false
                        },
                    })
                })
            },
        })
    }
};


const regroupHamburger = () => {
    if (hamburgerModel && !isAnimating) {
        isAnimating = true
        isHamburgerSeparated = false

        // Reset the rotation of the hamburger
        hamburgerModel.children.forEach((child) => {
            if (child.initialPosition) {
                gsap.to(child.position, {
                    x: child.initialPosition.x,
                    y: child.initialPosition.y,
                    z: child.initialPosition.z,
                    duration: 1.5,
                    ease: "power2.out",
                });
                gsap.to(child.rotation, {
                    x: 0,
                    y: 0,
                    z: 0,
                    duration: 1.5,
                    ease: "power2.out",
                    onComplete: () => {                    
                        returnHamburgerButton.style.display = 'none'
                        moveIngredientsButton.style.display = 'block'
                        isAnimating = false
                    },
                });
            }
        });

        allowHamburgerRotation = true
    }
};

// Event listener to hide the return button on load
window.addEventListener('load', () => {
    moveIngredientsButton.style.display = 'block'
    returnHamburgerButton.style.display = 'none'
});

/**
 * Event listeners for the buttons
 */
const moveIngredientsButton = document.getElementById('move-ingredients');
const returnHamburgerButton = document.getElementById('return-hamburger');

moveIngredientsButton.addEventListener('click', () => {
    if (!isAnimating) {
        moveIngredients()

        // Hide the current button with animation
        moveIngredientsButton.classList.remove('visible')
        moveIngredientsButton.classList.add('hidden')

        //Show the other button with animation
        setTimeout(() => {
            returnHamburgerButton.classList.remove('hidden')
            returnHamburgerButton.classList.add('visible')
        }, 1000)
    }
});

returnHamburgerButton.addEventListener('click', () => {
    if (!isAnimating) {
        regroupHamburger();

        // Hide the current button with animation
        returnHamburgerButton.classList.remove('visible')
        returnHamburgerButton.classList.add('hidden')

        // Show the other button with animation
        setTimeout(() => {
            moveIngredientsButton.classList.remove('hidden')
            moveIngredientsButton.classList.add('visible')
        }, 1000)
    }
});



/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))



/**
 * Animate
 */
let allowHamburgerRotation = true
const clock = new THREE.Clock()
const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    // Animate the hamburger rotation
    if (hamburgerModel && allowHamburgerRotation && !isDragging) {
        hamburgerModel.rotation.y += 0.002
    }

   // Animate the ingredients
   if (ingredientsVisible) {
    hamburgerModel.children.forEach((child) => {
        if (child.clonedChild) {
            
            const rotationAmplitude = 0.3
            const rotationSpeed = 0.2

            child.clonedChild.rotation.x = Math.sin(elapsedTime * rotationSpeed) * rotationAmplitude;
            child.clonedChild.rotation.y = Math.sin(elapsedTime * rotationSpeed) * rotationAmplitude;
        }
    });
}

    controls.update();

    renderer.render(scene, camera)
    
    window.requestAnimationFrame(tick)
}
tick()



/**
 * Event listeners for the header links
 */
const headerLinks = document.querySelectorAll('header nav a');
headerLinks.forEach(link => {
    link.addEventListener('click', (event) => {
        event.preventDefault();
        const targetUrl = event.target.href

        // Start the overlay animation
        gsap.to('#white-overlay', {
            duration: 1,
            opacity: 1,
            onComplete: () => {
                window.location.href = targetUrl
            }
        });
    });
});

// Fade-in effect on page load
window.addEventListener('load', () => {
    document.body.classList.add('loaded')
})

